import React from 'react';
import { BundleDetailTemplate } from './BundleDetailTemplate';

export const BundlePolicies = () => <BundleDetailTemplate slug="policies-bundle" />;
